module.exports = __webpack_public_path__ + "img/img2_icon.78913ceb.png";